import { useState } from 'react';

interface SkeletonImageProps {
  src: string;
  alt: string;
  className?: string;
}

export default function SkeletonImage({ src, alt, className = '' }: SkeletonImageProps) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="relative w-full h-full">
      {!loaded && <div className="absolute inset-0 bg-zinc-700 animate-pulse" />}
      <img
        src={src}
        alt={alt}
        style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.4s ease' }}
        className={`w-full h-full ${className}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
